export default __webpack_public_path__ + "static/media/trash_bin.a34c3b06.svg";